// Lenis Smooth Scroll Initialization
(function() {
  // Wait for Lenis to be loaded
  function initLenis() {
    if (typeof Lenis === 'undefined') {
      setTimeout(initLenis, 50);
      return;
    }

    // Initialize Lenis with optimized settings
    const lenis = new Lenis({
      duration: 1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
      autoResize: true,
      prevent: (node) => {
        // Prevent Lenis from affecting scroll inside modals, drawers, and popups
        return node.closest('.quick-add-modal__content, .quick-add-modal__content-info, .drawer__inner, cart-drawer-items, cart-drawer, details-modal[open], modal-dialog[open], [role="dialog"], .menu-drawer, .menu-drawer__navigation-container, .menu-drawer__inner-submenu, menu-drawer, header-drawer') !== null;
      }
    });

    // Request animation frame loop
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Expose lenis globally for other scripts
    window.lenis = lenis;

    // Debounce function to prevent excessive resize calls
    let resizeTimeout;
    const debouncedResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        lenis.resize();
      }, 150);
    };

    // Watch for window resize
    window.addEventListener('resize', debouncedResize);

    // Recalculate when images load
    window.addEventListener('load', () => {
      lenis.resize();
    });

    // Handle lazy-loaded images
    document.addEventListener('lazyloaded', debouncedResize);

    // MutationObserver to detect DOM changes that affect page height
    let mutationTimeout;
    const debouncedMutationResize = () => {
      clearTimeout(mutationTimeout);
      mutationTimeout = setTimeout(() => {
        lenis.resize();
      }, 100);
    };

    const observer = new MutationObserver((mutations) => {
      // Check if mutations actually affect layout 
      let shouldResize = false;
      
      for (const mutation of mutations) {
        // Check for added or removed nodes
        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
          shouldResize = true;
          break;
        }
        
        // Check for attribute changes that might affect layout
        if (mutation.type === 'attributes') {
          const attrName = mutation.attributeName;
          if (attrName === 'style' || attrName === 'class' || attrName === 'hidden') {
            shouldResize = true;
            break;
          }
        }
      }
      
      if (shouldResize) {
        debouncedMutationResize();
      }
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });

    // Shopify section events
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => lenis.resize(), 100);
    });

    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(() => lenis.resize(), 100);
    });

    // Handle anchor links smoothly
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          lenis.scrollTo(target, {
            offset: 0,
            duration: 1.1,
          });
        }
      });
    });

    console.log('✨ Lenis smooth scroll initialized');
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLenis);
  } else {
    initLenis();
  }
})();
